import React from 'react';
import PropTypes from 'prop-types';
import { Config } from '@deporvillage/utils-library-component';
import { cdn } from '@deporvillage/picture-component';
import Swiper, { SwiperArrowType } from '@deporvillage/swiper-component';
import Modal, { ModalType } from '@deporvillage/modal-component';
import ImageZoom from './ImageZoom';
import Thumbnails from './Thumbnails';

import styles from './Fullscreen.module.scss';

const Fullscreen = ({ initial, collection, onClick, onClose }) => {

    const { isMobile, cdn: cdnConfig } = React.useContext(Config)
    const [activeImage, setActive] = React.useState(initial);

    return (
        <div className={styles['fullscreen-component']}>
            <Modal type={ModalType.Fullscreen} onClose={() => onClose && onClose({ activeImage })}>
                <div className={styles['fullscreen-wrapper']}>

                    {
                        collection.length > 1 && !isMobile && (
                            <div className={styles['side-gallery']}>
                                <Thumbnails
                                    collection={collection}
                                    size={100}
                                    onClick={(idx) => setActive(idx)}
                                    onHover={(idx) => setActive(idx)}
                                />
                            </div>
                        )
                    }

                    <div className={styles['gallery-swiper']}>
                        {
                            !isMobile ? (
                                <ImageZoom
                                    key={collection[activeImage]}
                                    image={collection[activeImage]}
                                    zoomSize={1800}
                                />
                            ) : (
                                <Swiper
                                    zoom={isMobile}
                                    initial={initial}
                                    pagination={isMobile && collection.length > 1}
                                    bullets={3}
                                    arrows={SwiperArrowType.Bottom}
                                    click={onClick}
                                    loop
                                    lazy
                                >
                                    {
                                        collection.map((i, idx) => (
                                            <div
                                                key={`Picture${idx}`}
                                                className={`${styles['gallery-picture-wrapper']} swiper-zoom-container`}
                                            >
                                                <img src={cdn({ src: `product/${i}` }, cdnConfig)} />
                                            </div>
                                        ))
                                    }
                                </Swiper>

                            )
                        }

                    </div>

                </div>
            </Modal>
        </div>
    );
};

Fullscreen.propTypes = {
    initial: PropTypes.number,
    collection: PropTypes.arrayOf(
        PropTypes.string
    ),
    onClick: PropTypes.func,
    onClose: PropTypes.func,
};

export default Fullscreen;
